import request from '../../../config/Request'

const system = {
    lookUpQueryList:'/api/LookUp/queryList',// 查询快码信息列表
    lookUpQueryDetail:'/api/LookUp/queryDetail',// 查询快码信息详细
    lookUpEditDetail:'/api/LookUp/editDetail',// 编辑快码信息
    lookUpDelDetail:'/api/LookUp/delDetail',// 删除快码信息

    comQueryList:'/api/Compy/queryList',// 查询处置中心信息列表
    comQueryDetail:'/api/Compy/queryDetail',// 查询处置中心信息详细
    comEditDetail:'/api/Compy/editDetail',// 编辑处置中心信息
    comDelDetail:'/api/Compy/delDetail',// 删除处置中心信息

    configQueryList:'/api/Config/queryList',// 查询系统配置信息列表
    configQueryDetail:'/api/Config/queryDetail',// 查询系统配置信息详细
    configEditDetail:'/api/Config/editDetail',// 编辑系统配置信息
    configDelDetail:'/api/Config/delDetail',// 删除系统配置信息

    typeQueryList:'/api/GoodsType/queryList',// 查询货物类别信息列表
    typeQueryDetail:'/api/GoodsType/queryDetail',// 查询货物类别信息详细
    typeEditDetail:'/api/GoodsType/editDetail',// 编辑货物类别信息
    typeDelDetail:'/api/GoodsType/delDetail',// 删除货物类别信息

    appQueryList:'/api/app/queryList',//查询历史版本
    appEditDetail:'/api/app/editDetail',//修改版本信息
};
/**
 * 查询快码信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getLookUpQueryList(parameter) {
    return request({
        url: system.lookUpQueryList,
        data: parameter
    })
}
/**
 * 编辑快码信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function lookUpEditDetail(parameter) {
    return request({
        url: system.lookUpEditDetail,
        data: parameter
    })
}
/**
 * 删除快码信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function lookUpDelDetail(parameter) {
    return request({
        url: system.lookUpDelDetail,
        data: parameter
    })
}
/**
 * 查询处置中心信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getComQueryList(parameter) {
    return request({
        url: system.comQueryList,
        data: parameter
    })
}
/**
 * 编辑处置中心信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function comEditDetail(parameter) {
    return request({
        url: system.comEditDetail,
        data: parameter
    })
}
/**
 * 删除处置中心信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function comDelDetail(parameter) {
    return request({
        url: system.comDelDetail,
        data: parameter
    })
}
/**
 * 查询系统配置信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getConfigQueryList(parameter) {
    return request({
        url: system.configQueryList,
        data: parameter
    })
}
/**
 * 编辑系统配置信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function configEditDetail(parameter) {
    return request({
        url: system.configEditDetail,
        data: parameter
    })
}
/**
 * 删除系统配置信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function configDelDetail(parameter) {
    return request({
        url: system.configDelDetail,
        data: parameter
    })
}
/**
 * 查询货物类别信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getTypeQueryList(parameter) {
    return request({
        url: system.typeQueryList,
        data: parameter
    })
}
/**
 * 编辑货物类别信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function typeEditDetail(parameter) {
    return request({
        url: system.typeEditDetail,
        data: parameter
    })
}
/**
 * 删除货物类别信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function typeDelDetail(parameter) {
    return request({
        url: system.typeDelDetail,
        data: parameter
    })
}
/**
 * 查询app版本控制列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function appQueryList(parameter) {
    return request({
        url: system.appQueryList,
        data: parameter
    })
}
/**
 * 编辑app版本信息
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function appEditDetail(parameter) {
    return request({
        url: system.appEditDetail,
        data: parameter
    })
}
